<template>
  <div class="retrievePasswosrd">
    <new-head :title="title" class="pos-top"></new-head>

    <div class="statusBox" v-if="status == 0">
      <h2>请输入注册手机号</h2>
      <div class="ipt">
        <img src="@/assets/image/login-code.png" alt="" />
        <input type="number" v-model="phone" />
      </div>
      <button class="disable" v-if="phone.length != 11">获取短信验证码</button>
      <button v-else @click="phoneNext">获取短信验证码</button>
    </div>

    <div class="statusBox" v-if="status == 1">
      <h2>请输入新登录密码</h2>
      <div class="tip">密码为8-20位，至少包含字母，数字，符号2种组合</div>
      <div class="ipt">
        <img src="@/assets/image/job-password.png" alt="" />
        <input type="password" v-model="password" />
      </div>
      <button class="disable" v-if="password.length < 8">完成</button>
      <button v-else @click="passwordNext">完成</button>
    </div>

    <div class="statusBox" v-if="status == 2">
      <h2>请输入验证码</h2>
      <div class="tip">验证码已通过短信发送至+86 {{ this.phone }}</div>
      <div class="ipt">
        <img src="@/assets/image/login-phone.png" />
        <input placeholder="请输入验证码" type="number" v-model="code" />
        <div class="not" v-if="seconds > 0">{{ seconds }}秒后重试</div>
        <div v-else @click="sendCode">重新获取验证码</div>
      </div>
      <button v-if="code.length == 6" @click="codeNext">完成</button>
      <button v-else class="disable">完成</button>
    </div>
  </div>
</template>
<script>
import { getPin, changePwdApi } from "@/api/api/user";
export default {
  name: "retrievePasswosrd", //设置密码和找回密码共用一个页面
  data() {
    return {
      type: null, //1设置密码 2找回密码
      status: 0, // 0输入手机号 修改密码时无需输入  1输入密码阶段  2输入短信验证码阶段
      phone: "",
      password: "",
      code: "",
      seconds: 60,
      timer: null,
    };
  },
  computed: {
    title() {
      let { type, status } = this;
      if (type == 2) {
        if (status == 0) return "找回密码";
        if (status == 1) return "短信验证";
      }
      return "新密码设置";
    },
  },
  watch: {
    status(newVal) {
      console.log(newVal);
      if (newVal == 2) {
        this.timer = setInterval(() => {
          if (this.seconds <= 0) {
            clearInterval(this.timer);
          } else {
            this.seconds--;
          }
        }, 1000);
      }
    },
  },
  created() {
    let { type } = this.$route.query;
    if (type == 1) {
      this.phone = localStorage.getItem("phone");
      this.status = 1;
    }
    this.type = type;
  },
  methods: {
    async sendCode() {
      let res = await getPin(this.phone);
      if (res.data.errorCode == 0) {
        this.tip("发送成功");
        this.seconds = 60;
        this.timer = setInterval(() => {
          if (this.seconds <= 0) {
            clearInterval(this.timer);
          } else {
            this.seconds--;
          }
        }, 1000);
        return true;
      } else {
        this.tip(res.data.errorMsg)
      }
      return false;
    },
    async phoneNext() {
      let d = await this.sendCode();
      if (d) {
        this.status = 2;
      }
    },
    passwordNext() {
      let { password, type } = this;
      if (password.length > 20) return this.tip("密码过长");
      if (type == 1) {
        // this.status = 2;
        getPin(this.phone).then((res) => {
          console.log(res);
          if (res.data.errorCode == 0) {
            this.tip("已发送验证码");
            this.status = 2;
          }
        });
      } else {
        this.save();
      }
    },
    codeNext() {
      let { type } = this;
      if (type == 1) {
        this.save();
      } else {
        this.status = 1;
      }
    },
    save() {
      let { phone, password, code } = this;
      changePwdApi({ mobile: phone, code, password }).then((res) => {
        if(res.data.errorCode == '0') {
          this.tip('密码设置成功')
          this.$router.back()
        } else {
           this.tip(res.data.errorMsg)
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.retrievePasswosrd {
  padding: 64px 15px 20px;

  .statusBox {
    margin-top: 20px;
    .tip {
      margin-top: 20px;
    }
    .ipt {
      margin-top: 30px;
      height: 40px;
      background-color: #f6f6f6;
      display: flex;
      align-items: center;
      border: 1px solid #ccc;
      border-radius: 20px;
      overflow: hidden;
      img {
        width: 25px;
        height: 30px;
        margin: 0 10px;
      }
      input {
        flex: 1;
        height: 100%;
        background: none;
      }
      > div {
        width: 90px;
        text-align: center;
        height: 20px;
        font-size: 12px;
        line-height: 20px;
        color: #006bff;
        font-weight: 600;
        border: 1px solid #0286ff;
        border-radius: 10px;
        margin: 0 10px;
      }
      .not {
        color: #ccc;
      }
    }
    > button {
      width: 100%;
      height: 40px;
      border-radius: 8px;
      background-color: #0286ff;
      color: #fff;
      font-size: 18px;
      margin-top: 60px;
    }
    .disable {
      background-color: #ccc;
    }
  }
}
</style>
